<template>
  <div class="inline-block  w-full mt-10">
    <h1>Current Activity</h1>
    <h3 class="mb-4">Orders (To be fulfilled)</h3>
    <el-table
      :data="data"
      :empty-text="'No Data available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Order Id">
      </el-table-column>
      <el-table-column
        prop="monetary"
        label="Date Purchased">
      </el-table-column>
      <el-table-column
        prop="frequency_score"
        label="Product Name">
      </el-table-column>
      <el-table-column
        prop="recency_score"
        label="Product Category">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Product SubCategory">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Order Quantity">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Unit Price">
      </el-table-column>
    </el-table>
    <h3 class="mt-4 mb-4">Orders (To be Delivered)</h3>
    <el-table
      :data="data"
      :empty-text="'No Data available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Order Id">
      </el-table-column>
      <el-table-column
        prop="monetary"
        label="Date Purchased">
      </el-table-column>
      <el-table-column
        prop="frequency_score"
        label="Product Name">
      </el-table-column>
      <el-table-column
        prop="recency_score"
        label="Product Category">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Product SubCategory">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Order Quantity">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Unit Price">
      </el-table-column>
    </el-table>
    <h3 class="mt-4 mb-4">Orders (Returns/Faults/Incompletes)</h3>
    <el-table
      :data="data"
      :empty-text="'No Data available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Order Id">
      </el-table-column>
      <el-table-column
        prop="monetary"
        label="Date Purchased">
      </el-table-column>
      <el-table-column
        prop="frequency_score"
        label="Product Name">
      </el-table-column>
      <el-table-column
        prop="recency_score"
        label="Product Category">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Product SubCategory">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Order Quantity">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Unit Price">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'CurrentActivity',
  data() {
    return {
      data: [],
    };
  },
};
</script>

<style scoped>

</style>
